import React, { useEffect, useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { AppContext } from "../util/AppContext";
import { getPrescriberById } from '../API/prescriber'
import { getGroupPracticeById } from '../API/groupPractice';
import { getGeographyAggregateById } from '../API/geographyAggregate';
import { useErrorBoundary } from "react-error-boundary";
import { getConfigValue } from '../util/getConfigValue';
import { useRoutingValidation } from "../util/useRoutingValidation";
import MessageTypes from "../util/messageTypes";
import { hcpType, focusTypeName } from "../util/constants";



function AlignedMessagesForUserPage() {
	const [appState, setAppState] = useContext(AppContext);
	const { commonTerritoryId, prescriberId, level, productId, messageCode } = useParams();
	const { showBoundary } = useErrorBoundary();
	const navigate = useNavigate();
	const [invalidParams, setInvalidParams] = useState(false);

	useRoutingValidation();
	
	useEffect(() => {

		//Handle Config appState
		if (!appState.configLoaded || !appState.configRefreshed) {
			return;
		}

		//Set Market and Territory in AppState Function
		async function handleMarketTerritoryAppState() {
			let market = null;
			let territory = null;
			const markets = JSON.parse(sessionStorage.getItem('marketsForUser'));
			markets.forEach(m => {
				// check territory
				const t = m.territories.find(t => t.id === commonTerritoryId);
				if (t) {
					market = m;
					territory = t;
					return true;
				}
			});

			return [market, territory];
		};

		//Set Prescriber in AppState Function
		async function handlePrescriberAppState(prescriberId, marketId, territoryId) {
			let prescriber = null;
			let products = null;
			let prescriberType = null;
			const enabledProducts = appState.sellSheetProductDetails?.map(p => p.clientProductId);
			let apiFunction;
			if (level === hcpType.Prescriber) {
				apiFunction = getPrescriberById;
			} else if (level === hcpType.GroupPractice) {
				apiFunction = getGroupPracticeById;
			} else if (level === hcpType.GeographyAggregate) {
				apiFunction = getGeographyAggregateById;
			} else {
				throw new Error(`Unsupported level type: ${level}`);
			}
			await apiFunction(prescriberId, marketId, territoryId)
				.then(data => {
					prescriber = data;
					products = prescriber?.products.filter(product => enabledProducts.includes(product.productId)).map(product => product) || null;
					prescriberType = level;
				}).catch(error => { showBoundary(error) });
			return [prescriber, products, prescriberType]
		};

		//Set MessageCode in AppState Function
		function handleMessageCodeAppState(products) {
			const product = products?.find(i => i.productId === parseInt(productId));
			const message = product?.messages.find(m => m.messageCode === messageCode);
			return message;
		};

		function getNavigateUrl(message) {
			const isContainerMessage = message.isContainerMessage;
			if(message.messageType === MessageTypes.ImprovedAccess) {
				return '/WinPlanListPage';
			}
			if(isContainerMessage) {
				return '/ContainerMessagePage';
			}
			return '/PlanListPage';
		}

		// Navigate to PlanList Page 
		function navigatetoPlanListPage(category) {
			const url = getNavigateUrl(category);
			navigate(url)
		}

		const setStateData = async function () {
			if (!commonTerritoryId || !prescriberId || !level || !productId || !messageCode) {
				setInvalidParams(true);
				return;
			};

			let currentProduct = null;
			if (!appState?.sellSheetProductDetails) {
				return;
			};


			currentProduct = appState?.sellSheetProductDetails?.find(p => p.clientProductId === parseInt(productId));
			const [market, territory] = await handleMarketTerritoryAppState();

			if (!market || !territory) {
				setInvalidParams(true);
				return;
			}

			const [prescriber, products, prescriberType] = await handlePrescriberAppState(prescriberId, market?.id, territory?.id);
			const category = handleMessageCodeAppState(products);

			if (!prescriber || !products || !prescriberType || !category || !currentProduct) {
				setInvalidParams(true);
				return;
			}

			setAppState(prevState => {
				return {
						...prevState,
						market: market,
						territory: territory,
						prescriber: prescriber,
						products: products,
						prescriberType: prescriberType,
					category: category,
					currentProduct: currentProduct,
					focus: focusTypeName.HCPs
				}
			});
			navigatetoPlanListPage(category);
		};
		setStateData();

	}, [commonTerritoryId, prescriberId, level, productId, messageCode, appState?.sellSheetProductDetails, appState.configLoaded, appState.configRefreshed, showBoundary, navigate, setAppState])

	return invalidParams &&
		<div className="container-xl">
			<div className="row justify-content-center">
				<div className="col-12 col-sm-10 col-md-6">
					<div className="alert alert-danger mt-8" role="alert">
						<div className="alert-icon"></div>
						<div className="alert-content">
							<h4 className="h5 alert-heading">
								{getConfigValue(appState?.config?.MessagePlans?.ForUserErrorMessage?.Title, appState)?.Value || null}</h4>
							<p>{getConfigValue(appState?.config?.MessagePlans?.ForUserErrorMessage?.Label, appState)?.Value || null}</p>
							<p>{getConfigValue(appState?.config?.MessagePlans?.ForUserErrorMessage?.Body, appState)?.Value || null}</p>
						</div>
					</div>
					<div className="text-center mt-5">
						<Link
							to='/'
							className='btn btn-primary btn-lg'>
							{getConfigValue(appState.config?.MessagePlans?.PrintOnDemand?.Label, appState)?.Value}
						</Link>
					</div>
				</div>
			</div>
		</div>

}

export default AlignedMessagesForUserPage;